import { render, staticRenderFns } from "./Project_Type.vue?vue&type=template&id=5e4bf774&"
import script from "./Project_Type.vue?vue&type=script&lang=js&"
export * from "./Project_Type.vue?vue&type=script&lang=js&"
import style0 from "./Project_Type.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports